import { Dialog, Transition } from '@headlessui/react'
import classNames from 'classnames'
import { t } from 'i18next'
import { Fragment, ReactNode } from 'react'

interface IModal {
    title: string
    isOpen: boolean
    disabled?: boolean
    showSubmitBtn?: boolean
    children: ReactNode
    saveBtnText?: string
    handleSave?: () => void
    height?: string
    width?: string
    className?: string
}

export default function Modal(props: IModal) {
    // let [isOpen, setIsOpen] = useState(true)

    // function closeModal() {
    //   setIsOpen(false)
    // }

    // function openModal() {
    //   setIsOpen(true)
    // }

    return (
        <>
            <Transition appear show={props.isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={() => { }}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto backdrop-blur-lg">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel
                                    className={classNames(
                                        'transform overflow-hidden bg-white p-6 align-middle shadow-xl transition-all ',
                                        props.height ? props.height : 'h-96',
                                        props.width ? props.width : 'w-[35rem]'
                                    )}
                                >
                                    <div className="justify-center items-center flex flex-col">
                                        <Dialog.Title
                                            as="h4"
                                            className="text-md font-medium leading-6 text-gray-900 pt-1"
                                        >
                                            {props.title}
                                        </Dialog.Title>
                                        {props.children}

                                        {props.showSubmitBtn && (
                                            <div className="mb-4">
                                                <button
                                                    type="button"
                                                    className="inline-flex justify-center border border-transparent bg-blue-100 px-16 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                                    onClick={props.handleSave}
                                                    disabled={props.disabled}
                                                >
                                                    {props.saveBtnText ||
                                                        t('continue') ||
                                                        ''}
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}
